<template>
  <ProjectDetail />
</template>

<script>
  import ProjectDetail from '../projectDetail/index.vue';
  export default {
    name: 'ProjectRecord',
    components: {
      ProjectDetail,
    },
  };
</script>
